export function intTo4digitsString(nb) {
  if(nb > 0 && nb < 10)
    return "000"+nb;
  else if(nb >= 10 && nb < 100)
    return "00"+nb;
  else if(nb >= 100 && nb < 1000)
    return "0"+nb;
  else if(nb >= 1000)
    return +nb;
}